export type ModuleSlug = "spreken" | "schrijven" | "lezen" | "luisteren" | "knm";

export const MODULE_SLUGS: readonly ModuleSlug[] = [
  "spreken",
  "schrijven",
  "lezen",
  "luisteren",
  "knm",
] as const;

export type ModuleStatus = "active" | "binnenkort" | "hidden";

export const MODULE_STATUSES: readonly ModuleStatus[] = [
  "active",
  "binnenkort",
  "hidden",
] as const;

export type ModuleDefinition = {
  label: string;
  route: string;
};

export const MODULE_DEFINITIONS: Record<ModuleSlug, ModuleDefinition> = {
  spreken:   { label: "Spreken",   route: "/spreken" },
  schrijven: { label: "Schrijven", route: "/schrijven" },
  lezen:     { label: "Lezen",     route: "/lezen" },
  luisteren: { label: "Luisteren", route: "/luisteren" },
  knm:       { label: "KNM",       route: "/knm" },
};

export function isModuleSlug(v: unknown): v is ModuleSlug {
  return typeof v === "string" && (MODULE_SLUGS as readonly string[]).includes(v);
}

export type ModuleStatusMap = Record<ModuleSlug, ModuleStatus>;
